"use client"

import { useFetchPostsByCategory } from "@/hook/useFetchPostsByCategory"
import { useMemo } from "react"
import { mapPostToArticle } from "../utils/utils"

interface UseLatestNewsOptions {
    page?: number
    pageSize?: number
    locale?: string
    domain?: string
}

export const useLatestNews = (options: UseLatestNewsOptions = {}) => {
    const { page = 1, pageSize = 10, locale, domain = "" } = options

    // No category filter: fetch every live post assigned to this domain.
    const { posts, loading, error, totalPages } = useFetchPostsByCategory({
        categoryIds: [],
        page,
        pageSize,
        locale,
        domain,
    })

    // Trả [] khi rỗng (không phải undefined): LatestNewsContent chỉ hiện skeleton khi
    // articles === undefined, nên rỗng = undefined sẽ kẹt skeleton mãi. Chỉ để undefined
    // ở lần đầu chưa fetch (loading), còn lại luôn là mảng thật kể cả rỗng.
    const articles = useMemo(() => {
        if (loading) return undefined
        return (posts ?? []).map(mapPostToArticle)
    }, [posts, loading])

    return { articles, loading, error, totalPages }
}
